<div class="modal-header">
  <div class="font-xl fw-bold text-center px-5"
       [translate]="'modal.deliveryCheck.header'">
    Delivery times
    <i class="icon-close" (click)="modal.dismiss()"></i>
  </div>
</div>

<div class="modal-body modal-body-delivery-check">
  <div class="position-relative">
    <label class="fw-bold font-xl"
           [translate]="'common.enterPostCode'"></label>

    <bakery-delivery-check
      [bakeryId]="bakery.id"
      [country]="bakery.country"
    ></bakery-delivery-check>
  </div>

  <div class="cd-cake-img mt-4"
       [style.backgroundImage]="'url(' + (productType.image | multiUrlImage: 'original' : '/assets/img/content/default-cake-image.jpg') + ')'">
  </div>

  <div class="clearfix mt-2">
    <div class="float-start">
      <strong>{{productType.name}}</strong>
    </div>

    <div class="float-end text-end cake-price"
         *ngIf="!productType.pieces">
        <span class="font-mute font-sm"
              [translate]="'common.from'"></span>
      <strong> {{productType.minPrice | currencyFormat}} </strong>
      <span class="font-mute font-sm">{{bakeryCurrency}}</span>
    </div>

    <div class="float-end text-end"
         *ngIf="productType.pieces">
      <strong> {{productType.minPrice | currencyFormat}} </strong>

      <span class="font-mute font-sm">
        {{ bakeryCurrency }}&nbsp;{{ 'cakeBuilder.sizeUnits.unitType.' + productType.sizeUnit | translate }}
      </span>
    </div>
  </div>

  <div class="font-sm">
    <a class="text-muted" [routerLink]="[bakeryOverviewUrl]">{{productType.bakery.name}}</a>
  </div>

  <div class="row mt-4 mb-2">
    <div class="offset-sm-2 col-sm-8 offset-md-1 col-md-10">
      <button class="btn btn-pink d-block w-100"
              [translate]="'modal.deliveryCheck.orderCakeBtn'"
              (click)="orderCake()">
        Order cake
      </button>
    </div>
  </div>

</div>
